import React, {useEffect} from "react";
import $ from 'jquery';
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_URL;

    let table = $('#banners').DataTable({
      "bFilter": false,
      "ajax": {
        url: `${baseUrl}banners`,
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.post('/logout')
              .then(res => {
                localStorage.removeItem('persist:root');
                navigate('/login');
              });
          }
        }
      },
      "columns": [
        {data: 'page', name: 'page'},
        {data: 'position', name: 'position'},
        {data: 'start_date', name: 'start_date'},
        {data: 'end_date', name: 'end_date'},
        {data: 'is_active', name: 'is_active'},
        {
          data: 'edit',
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            return `<button 
                class="btn btn-primary me-2 mb-2 bg-black-transperent edit"
                row-id="${row.id}">
                  Edit
                </button>`;
          },
        }
      ],
      columnDefs: [
        {
          targets: [0],
          orderData: [0, 1],
        },
      ],
    });

    table.on('click', 'button.edit', function () {
      const id = $(this).attr("row-id");
      navigate(`/banners/${id}/edit`);
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");
  }, []);

  return (
    <div>
      <table id="banners" className="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
        <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
          <th>Page</th>
          <th>Position</th>
          <th>Start date</th>
          <th>End date</th>
          <th>Active</th>
          <th>Edit</th>
        </tr>
        </thead>
        <tbody className="text-gray-600 fw-bold">
        </tbody>
      </table>
    </div>
  );
}